/** @format */

const template = `
<div class="container messages">
  <div class="row">
    <div class="col-12">
      <div class="messages-container">
        <div class="row opened-message">
          <div class="col-12">
            <div class="top-button-container">
              <button type="button" class="btn btn-secondary btn-hollow btn-sm" ng-click="$ctrl.closeMessage()">
                <sis-icon icon="back"></sis-icon>
                <span translate="SIS_COMPONENTS.BUTTON.BACK"></span>
              </button>
            </div>
          </div>
          <div class="col-12 opened-message-content">
            <div class="message-info-header-collapsed" aria-hidden="true">
              <div class="row">
                <div class="col-12 message-meta">
                  <div class="message-sender">
                    <h4 translate="SIS_COMPONENTS.MESSENGER.SENDER"></h4>
                    <span ng-if="$ctrl.showSenderFullName()">{{$ctrl.message.senderFullName}}</span>
                    <span ng-if="!$ctrl.showSenderFullName()">{{$ctrl.message.senderName|localizedString}}</span>
                    <span ng-if="$ctrl.message.senderStudentNumber">({{$ctrl.message.senderStudentNumber}})</span>
                  </div>
                  <div class="message-date">{{$ctrl.message.messageTime | localDateTimeFormat}}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 message-title">
                  <h1 tabindex="-1" ng-if="$ctrl.message.title">{{$ctrl.message.title}}</h1>
                  <h1 tabindex="-1" ng-if="$ctrl.message.localizedTitle">{{$ctrl.message.localizedTitle|localizedString}}</h1>
                  <h1 tabindex="-1" ng-if="!$ctrl.message.title && !$ctrl.message.localizedTitle" translate
                    >{{$ctrl.getMessageTypeTranslationKey($ctrl.message)}}</h1
                  >
                </div>
              </div>
            </div>
            <div class="message-info-header">
              <div class="row">
                <div class="col-12 col-md-7">
                  <div class="row">
                    <div class="col-12 message-meta">
                      <div class="message-sender">
                        <h4 translate="SIS_COMPONENTS.MESSENGER.SENDER"></h4>
                        <span ng-if="$ctrl.showSenderFullName()">{{$ctrl.message.senderFullName}}</span>
                        <span ng-if="!$ctrl.showSenderFullName()">{{$ctrl.message.senderName|localizedString}}</span>
                        <span ng-if="$ctrl.message.senderStudentNumber">({{$ctrl.message.senderStudentNumber}})</span>
                      </div>
                    </div>
                  </div>
                  <div ng-if="$ctrl.isCourseUnitRealisationMessage($ctrl.message)" class="row">
                    <div class="col-12 message-cur-name-header">
                      <h4 translate="SIS_COMPONENTS.MESSENGER.TEACHING"></h4>
                      {{$ctrl.message.courseUnitRealisation.fullName | localizedString}}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-5 message-type-and-date">
                  <div class="message-type-header">
                    <span>{{$ctrl.getMessageTypeTranslationKey($ctrl.message) | translate}} {{$ctrl.messageTargetName}}</span>
                  </div>
                  <div class="message-date">{{$ctrl.message.messageTime | localDateTimeFormat}}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 message-title">
                  <h1 tabindex="-1" ng-if="$ctrl.message.title">{{$ctrl.message.title}}</h1>
                  <h1 tabindex="-1" ng-if="$ctrl.message.localizedTitle">{{$ctrl.message.localizedTitle|localizedString}}</h1>
                  <h1 tabindex="-1" ng-if="!$ctrl.message.title && !$ctrl.message.localizedTitle"
                    >{{$ctrl.getMessageTypeTranslationKey($ctrl.message) | translate}} {{$ctrl.messageTargetName}}</h1
                  >
                </div>
              </div>
            </div>
            <div class="message-content">
              <div ng-if="$ctrl.isSuggestionForAddition($ctrl.message)" class="suggestion-for-addition">
                <p
                  translate="SIS_COMPONENTS.MESSENGER.SUGGEST_ADD.SENT_BY_TUTOR"
                  translate-value-name="{{$ctrl.message.senderFullName}}"></p>
                <div class="row">
                  <div class="col-6">
                    <sis-course-unit-box
                      ng-if="$ctrl.message.courseUnitId"
                      [course-unit-id]="$ctrl.message.courseUnitId"></sis-course-unit-box>
                    <sis-module-box ng-if="$ctrl.message.moduleId" [module-id]="$ctrl.message.moduleId"></sis-module-box>
                  </div>
                </div>
                <p
                  ng-if="$ctrl.suggestionForAdditionParentModule"
                  class="parent-module-info"
                  translate="SIS_COMPONENTS.MESSENGER.SUGGEST_ADD.UNDER_MODULE"
                  translate-value-code="{{$ctrl.suggestionForAdditionParentModule.code}}"
                  translate-value-name="{{$ctrl.suggestionForAdditionParentModule.name | localizedString}}"></p>
                <h4 class="message-comment-title"> {{::'SIS_COMPONENTS.MESSENGER.SUGGEST_ADD.MESSAGE_FROM_TUTOR' | translate}}: </h4>
              </div>
              <div ng-if="$ctrl.message.comment" class="message-comment">{{$ctrl.message.comment}}</div>
              <div ng-if="$ctrl.message.localizedComment" class="message-comment">
                <sis-localized-markup-string-view [content]="$ctrl.message.localizedComment"></sis-localized-markup-string-view>
              </div>
              <div class="button-holder">
                <div ng-if="$ctrl.isApplicationMessage($ctrl.message)">
                  <div ng-switch on="$ctrl.message.operationType">
                    <div ng-switch-when="REQUESTED">
                      <div ng-if="$ctrl.isPriorLearningApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_PRIOR_LEARNING_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isModuleAttainmentApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_MODULE_ATTAINMENT_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isDegreeProgrammeAttainmentApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_DEGREE_PROGRAMME_ATTAINMENT_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isCustomAttainmentApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_CUSTOM_ATTAINMENT_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isModuleContentApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_APPLICATION
                        </button>
                      </div>
                      <div ng-if="$ctrl.isStudyRightExtensionApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_STUDY_RIGHT_EXTENSION_MESSAGE
                        </button>
                      </div>
                    </div>
                    <div ng-switch-when="CANCELLED">
                      <div ng-if="$ctrl.isPriorLearningApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_CANCELLED_PRIOR_LEARNING_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isModuleAttainmentApplicationMessage($ctrl.message)">
                        <button
                          type="button"
                          class="btn btn-primary btn-naked btn-sm"
                          ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_IN_PLAN
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_CANCELLED_MODULE_ATTAINMENT_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isDegreeProgrammeAttainmentApplicationMessage($ctrl.message)">
                        <button
                          type="button"
                          class="btn btn-primary btn-naked btn-sm"
                          ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_IN_PLAN
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_CANCELLED_DEGREE_PROGRAMME_ATTAINMENT_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isCustomAttainmentApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_CANCELLED_CUSTOM_ATTAINMENT_MESSAGE
                        </button>
                      </div>
                      <div ng-if="$ctrl.isModuleContentApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_CANCELLED_APPLICATION
                        </button>
                      </div>
                      <div ng-if="$ctrl.isStudyRightExtensionApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_CANCELLED_STUDY_RIGHT_EXTENSION_MESSAGE
                        </button>
                      </div>
                    </div>
                    <div ng-switch-when="ACCEPTED">
                      <button
                        ng-if="!$ctrl.isModuleContentApplicationMessage($ctrl.message) && !$ctrl.isStudyRightExtensionApplicationMessage($ctrl.message)"
                        type="button"
                        class="btn btn-primary btn-naked btn-sm"
                        ng-click="$ctrl.openAttainment($ctrl.message)"
                        translate
                        >SIS_COMPONENTS.MESSENGER.SHOW_ATTAINMENT
                      </button>
                      <button
                        ng-if="$ctrl.isPriorLearningApplicationMessage($ctrl.message)"
                        type="button"
                        class="btn btn-primary btn-naked btn-sm"
                        ng-click="$ctrl.goToApplication($ctrl.message)"
                        translate
                        >SIS_COMPONENTS.MESSENGER.SHOW_DECISION
                      </button>
                      <button
                        ng-if="$ctrl.message.isPriorLearningInclusionApplicationMessage"
                        type="button"
                        class="btn btn-primary btn-sm"
                        ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                        translate
                        >SIS_COMPONENTS.MESSENGER.PLACE_ATTAINMENT
                      </button>
                      <button
                        ng-if="$ctrl.isCustomAttainmentApplicationMessage($ctrl.message)"
                        type="button"
                        class="btn btn-primary btn-naked btn-sm"
                        ng-click="$ctrl.goToApplication($ctrl.message)"
                        translate
                        >SIS_COMPONENTS.MESSENGER.SHOW_DECISION
                      </button>
                      <button
                        ng-if="$ctrl.isCustomAttainmentApplicationMessage($ctrl.message)"
                        type="button"
                        class="btn btn-primary btn-sm"
                        ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                        translate
                        >SIS_COMPONENTS.MESSENGER.PLACE_ATTAINMENT
                      </button>
                      <div ng-if="$ctrl.isModuleContentApplicationMessage($ctrl.message)">
                        <button
                          type="button"
                          class="btn btn-primary btn-naked btn-sm"
                          ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_IN_PLAN
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_DECISION
                        </button>
                      </div>
                      <button
                        ng-if="$ctrl.isStudyRightExtensionApplicationMessage($ctrl.message)"
                        type="button"
                        class="btn btn-primary btn-sm"
                        ng-click="$ctrl.goToApplication($ctrl.message)"
                        translate
                        >SIS_COMPONENTS.MESSENGER.SHOW_DECISION
                      </button>
                    </div>
                    <div ng-switch-when="REJECTED">
                      <div ng-if="$ctrl.isPriorLearningApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_REJECTED_DECISION
                        </button>
                      </div>
                      <div ng-if="$ctrl.isModuleAttainmentApplicationMessage($ctrl.message)">
                        <button
                          type="button"
                          class="btn btn-primary btn-naked btn-sm"
                          ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_MODULE_IN_PLAN
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_REJECTED_MODULE_ATTAINMENT_DECISION
                        </button>
                      </div>
                      <div ng-if="$ctrl.isDegreeProgrammeAttainmentApplicationMessage($ctrl.message)">
                        <button
                          type="button"
                          class="btn btn-primary btn-naked btn-sm"
                          ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_DEGREE_PROGRAMME_IN_PLAN
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_REJECTED_DEGREE_PROGRAMME_ATTAINMENT_DECISION
                        </button>
                      </div>
                      <div ng-if="$ctrl.isCustomAttainmentApplicationMessage($ctrl.message)">
                        <button
                          ng-if="$ctrl.isCustomAttainmentApplicationMessage($ctrl.message)"
                          type="button"
                          class="btn btn-primary btn-sm"
                          ng-click="$ctrl.goToApplication($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_REJECTED_DECISION
                        </button>
                      </div>
                      <div ng-if="$ctrl.isModuleContentApplicationMessage($ctrl.message)">
                        <button
                          type="button"
                          class="btn btn-primary btn-naked btn-sm"
                          ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_IN_PLAN
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_DECISION
                        </button>
                      </div>
                      <div ng-if="$ctrl.isStudyRightExtensionApplicationMessage($ctrl.message)">
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_REJECTED_DECISION
                        </button>
                      </div>
                    </div>
                    <div ng-switch-when="CONDITIONAL">
                      <div ng-if="$ctrl.isModuleContentApplicationMessage($ctrl.message)">
                        <button
                          type="button"
                          class="btn btn-primary btn-naked btn-sm"
                          ng-click="$ctrl.openMessageInPlan($ctrl.message)"
                          translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_IN_PLAN
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                          >SIS_COMPONENTS.MESSENGER.SHOW_DECISION
                        </button>
                      </div>
                    </div>
                    <div ng-switch-default>
                      <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToApplication($ctrl.message)" translate
                        >SIS_COMPONENTS.MESSENGER.SHOW_PRIOR_LEARNING_MESSAGE
                      </button>
                    </div>
                  </div>
                </div>
                <div ng-if="$ctrl.isCourseUnitRealisationMessage($ctrl.message)">
                  <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToCalendar()" translate
                    >SIS_COMPONENTS.MESSENGER.OPEN_CALENDAR
                  </button>
                </div>
                <div ng-if="$ctrl.isCourseUnitManualEvaluationRequiredMessage($ctrl.message)">
                  <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToCourseUnitEvaluation()" translate
                    >SIS_COMPONENTS.MESSENGER.OPEN_COURSE_UNIT_EVALUATION
                  </button>
                </div>
                <div ng-if="$ctrl.showPlanMessageButton()">
                  <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.openMessageInPlan($ctrl.message)" translate
                    >SIS_COMPONENTS.MESSENGER.SHOW_IN_PLAN
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default template;
